/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  CreateHelpTicketResponse,
  FoodTransactionHistoryResponse,
  FuelTransactionHistoryResponse,
  GameHealthResponse,
  GameStatsResponse,
  GamingXPTransactionHistoryResponse,
  GetAllGamesQuestsResponse,
  GetCompetitiveTierResponse,
  GetFavoriteGamesResponse,
  GetHeroGamesResponse,
  GetPopularQuestGamesResponse,
  GetUserQuestStatsResponse,
  LastSessionResponse,
  LootboxRedemptionTransactionHistoryResponse,
  LootboxTransactionHistoryResponse,
  LootshopCreditTransactionHistoryResponse,
  LootshopTransactionHistoryResponse,
  MyNetworkStatusResponse,
  PlayStatsResponse,
  TimeFilter,
  XPTransactionHistoryResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CreateHelpTicketResponseFromJSON,
    CreateHelpTicketResponseToJSON,
    FoodTransactionHistoryResponseFromJSON,
    FoodTransactionHistoryResponseToJSON,
    FuelTransactionHistoryResponseFromJSON,
    FuelTransactionHistoryResponseToJSON,
    GameHealthResponseFromJSON,
    GameHealthResponseToJSON,
    GameStatsResponseFromJSON,
    GameStatsResponseToJSON,
    GamingXPTransactionHistoryResponseFromJSON,
    GamingXPTransactionHistoryResponseToJSON,
    GetAllGamesQuestsResponseFromJSON,
    GetAllGamesQuestsResponseToJSON,
    GetCompetitiveTierResponseFromJSON,
    GetCompetitiveTierResponseToJSON,
    GetFavoriteGamesResponseFromJSON,
    GetFavoriteGamesResponseToJSON,
    GetHeroGamesResponseFromJSON,
    GetHeroGamesResponseToJSON,
    GetPopularQuestGamesResponseFromJSON,
    GetPopularQuestGamesResponseToJSON,
    GetUserQuestStatsResponseFromJSON,
    GetUserQuestStatsResponseToJSON,
    LastSessionResponseFromJSON,
    LastSessionResponseToJSON,
    LootboxRedemptionTransactionHistoryResponseFromJSON,
    LootboxRedemptionTransactionHistoryResponseToJSON,
    LootboxTransactionHistoryResponseFromJSON,
    LootboxTransactionHistoryResponseToJSON,
    LootshopCreditTransactionHistoryResponseFromJSON,
    LootshopCreditTransactionHistoryResponseToJSON,
    LootshopTransactionHistoryResponseFromJSON,
    LootshopTransactionHistoryResponseToJSON,
    MyNetworkStatusResponseFromJSON,
    MyNetworkStatusResponseToJSON,
    PlayStatsResponseFromJSON,
    PlayStatsResponseToJSON,
    TimeFilterFromJSON,
    TimeFilterToJSON,
    XPTransactionHistoryResponseFromJSON,
    XPTransactionHistoryResponseToJSON,
} from '../models/index';

export interface CreateDevourplayHelpTicketRequest {
    logFile: Blob;
    name?: string;
    description?: string;
}

export interface GetDevourplayFavoriteGamesRequest {
    limit?: number;
}

export interface GetDevourplayGameStatsGameIdRequest {
    gameId: string;
    timeFilter?: TimeFilter;
}

export interface GetDevourplayPlayStatsRequest {
    timeFilter?: TimeFilter;
    startDate?: Date;
    endDate?: Date;
}

export interface GetDevourplayPopularQuestGamesRequest {
    limit?: number;
}

export interface GetDevourplayTransactionHistoryFoodRequest {
    timeFilter?: TimeFilter;
    limit?: number;
    offset?: number;
}

export interface GetDevourplayTransactionHistoryFuelRequest {
    timeFilter?: TimeFilter;
    limit?: number;
    offset?: number;
}

export interface GetDevourplayTransactionHistoryGamingXpRequest {
    timeFilter?: TimeFilter;
    limit?: number;
    offset?: number;
}

export interface GetDevourplayTransactionHistoryLootboxRedemptionRequest {
    timeFilter?: TimeFilter;
    limit?: number;
    offset?: number;
}

export interface GetDevourplayTransactionHistoryLootboxesRequest {
    timeFilter?: TimeFilter;
    limit?: number;
    offset?: number;
}

export interface GetDevourplayTransactionHistoryLootshopRequest {
    timeFilter?: TimeFilter;
    limit?: number;
    offset?: number;
}

export interface GetDevourplayTransactionHistoryLootshopCreditRequest {
    timeFilter?: TimeFilter;
    startDate?: string;
    endDate?: string;
    limit?: number;
    offset?: number;
}

export interface GetDevourplayTransactionHistoryXpRequest {
    timeFilter?: TimeFilter;
    startDate?: Date;
    endDate?: Date;
    limit?: number;
    offset?: number;
}

export interface GetDevourplayUserQuestStatsRequest {
    gameId?: string;
    rewardId?: string;
    rewardCategory?: GetDevourplayUserQuestStatsRewardCategoryEnum;
    page?: number;
    pageSize?: number;
    daysBack?: number;
}

export interface GetGameHealthGameIdRequest {
    gameId: string;
}

/**
 * DevourPlayApi - interface
 * 
 * @export
 * @interface DevourPlayApiInterface
 */
export interface DevourPlayApiInterface {
    /**
     * Stores a zipped log bundle from the DevourPlay Electron client. Anonymous uploads are accepted under `anonymous/`. Max 10MB.
     * @param {Blob} logFile Zipped Electron log bundle (max 10MB).
     * @param {string} [name] 
     * @param {string} [description] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevourPlayApiInterface
     */
    createDevourplayHelpTicketRaw(requestParameters: CreateDevourplayHelpTicketRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateHelpTicketResponse>>;

    /**
     * Stores a zipped log bundle from the DevourPlay Electron client. Anonymous uploads are accepted under `anonymous/`. Max 10MB.
     */
    createDevourplayHelpTicket(requestParameters: CreateDevourplayHelpTicketRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateHelpTicketResponse>;

    /**
     * Get all games with their quests and user progress in a single optimized call.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevourPlayApiInterface
     */
    getDevourplayAllGamesQuestsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllGamesQuestsResponse>>;

    /**
     * Get all games with their quests and user progress in a single optimized call.
     */
    getDevourplayAllGamesQuests(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllGamesQuestsResponse>;

    /**
     * 
     * @summary Get the authenticated user\'s DevourPlay Competitive Tier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevourPlayApiInterface
     */
    getDevourplayCompetitiveTierRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCompetitiveTierResponse>>;

    /**
     * Get the authenticated user\'s DevourPlay Competitive Tier
     */
    getDevourplayCompetitiveTier(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCompetitiveTierResponse>;

    /**
     * Get user\'s favorite games ranked by total play time
     * @param {number} [limit] Maximum number of games to return (default 10, max 300 — the Your Roster page requests every tracked game, not just the homepage carousel\&#39;s top few)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevourPlayApiInterface
     */
    getDevourplayFavoriteGamesRaw(requestParameters: GetDevourplayFavoriteGamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFavoriteGamesResponse>>;

    /**
     * Get user\'s favorite games ranked by total play time
     */
    getDevourplayFavoriteGames(requestParameters: GetDevourplayFavoriteGamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFavoriteGamesResponse>;

    /**
     * Get user\'s stats for a specific game with time filtering. Aggregates XP from time-played rewards (via OWReward) and quest rewards (via QuestConfig).
     * @param {string} gameId The game ID - can be Overwolf game ID (e.g. \&quot;21566\&quot;) or MongoDB ObjectId of the OWGame
     * @param {TimeFilter} [timeFilter] Time period for filtering stats (day/week/month/all). Defaults to \&#39;all\&#39;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevourPlayApiInterface
     */
    getDevourplayGameStatsGameIdRaw(requestParameters: GetDevourplayGameStatsGameIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GameStatsResponse>>;

    /**
     * Get user\'s stats for a specific game with time filtering. Aggregates XP from time-played rewards (via OWReward) and quest rewards (via QuestConfig).
     */
    getDevourplayGameStatsGameId(requestParameters: GetDevourplayGameStatsGameIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GameStatsResponse>;

    /**
     * The five games the Play hero rotates through, most recently played first. Distinct from /devourplay/favorite-games, which returns the user\'s FULL roster ranked by total playtime for the roster grid — this returns a fixed five-slot rotation, seeded from the weekly platform top five for a user with no play history so the hero is never empty. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevourPlayApiInterface
     */
    getDevourplayHeroGamesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetHeroGamesResponse>>;

    /**
     * The five games the Play hero rotates through, most recently played first. Distinct from /devourplay/favorite-games, which returns the user\'s FULL roster ranked by total playtime for the roster grid — this returns a fixed five-slot rotation, seeded from the weekly platform top five for a user with no play history so the hero is never empty. 
     */
    getDevourplayHeroGames(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetHeroGamesResponse>;

    /**
     * Gets the user\'s last gaming session and recent activity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevourPlayApiInterface
     */
    getDevourplayLastSessionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LastSessionResponse>>;

    /**
     * Gets the user\'s last gaming session and recent activity
     */
    getDevourplayLastSession(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LastSessionResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevourPlayApiInterface
     */
    getDevourplayMyNetworkStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MyNetworkStatusResponse>>;

    /**
     */
    getDevourplayMyNetworkStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MyNetworkStatusResponse>;

    /**
     * Get user\'s play statistics with time filtering
     * @param {TimeFilter} [timeFilter] Time period for filtering stats (defaults to \&#39;all\&#39;). Use \&#39;custom\&#39; with startDate and endDate for custom ranges.
     * @param {Date} [startDate] Start date for custom range (ISO string). Required when timeFilter is \&#39;custom\&#39;.
     * @param {Date} [endDate] End date for custom range (ISO string). Required when timeFilter is \&#39;custom\&#39;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevourPlayApiInterface
     */
    getDevourplayPlayStatsRaw(requestParameters: GetDevourplayPlayStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlayStatsResponse>>;

    /**
     * Get user\'s play statistics with time filtering
     */
    getDevourplayPlayStats(requestParameters: GetDevourplayPlayStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlayStatsResponse>;

    /**
     * Get the most popular quest-enabled games ranked by total play time across all users
     * @param {number} [limit] Maximum number of games to return (default 15, max 30)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevourPlayApiInterface
     */
    getDevourplayPopularQuestGamesRaw(requestParameters: GetDevourplayPopularQuestGamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPopularQuestGamesResponse>>;

    /**
     * Get the most popular quest-enabled games ranked by total play time across all users
     */
    getDevourplayPopularQuestGames(requestParameters: GetDevourplayPopularQuestGamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPopularQuestGamesResponse>;

    /**
     * Get user\'s food order history with time filtering and pagination
     * @param {TimeFilter} [timeFilter] Time period for filtering transactions (defaults to \&#39;all\&#39;)
     * @param {number} [limit] Number of transactions to return
     * @param {number} [offset] Number of transactions to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevourPlayApiInterface
     */
    getDevourplayTransactionHistoryFoodRaw(requestParameters: GetDevourplayTransactionHistoryFoodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FoodTransactionHistoryResponse>>;

    /**
     * Get user\'s food order history with time filtering and pagination
     */
    getDevourplayTransactionHistoryFood(requestParameters: GetDevourplayTransactionHistoryFoodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FoodTransactionHistoryResponse>;

    /**
     * Get user\'s Fuel transaction history with time filtering and pagination
     * @param {TimeFilter} [timeFilter] Time period for filtering transactions (defaults to \&#39;all\&#39;)
     * @param {number} [limit] Number of transactions to return
     * @param {number} [offset] Number of transactions to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevourPlayApiInterface
     */
    getDevourplayTransactionHistoryFuelRaw(requestParameters: GetDevourplayTransactionHistoryFuelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FuelTransactionHistoryResponse>>;

    /**
     * Get user\'s Fuel transaction history with time filtering and pagination
     */
    getDevourplayTransactionHistoryFuel(requestParameters: GetDevourplayTransactionHistoryFuelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FuelTransactionHistoryResponse>;

    /**
     * Get user\'s gaming XP transaction history with time filtering and pagination
     * @param {TimeFilter} [timeFilter] Time period for filtering transactions (defaults to \&#39;all\&#39;)
     * @param {number} [limit] Number of transactions to return
     * @param {number} [offset] Number of transactions to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevourPlayApiInterface
     */
    getDevourplayTransactionHistoryGamingXpRaw(requestParameters: GetDevourplayTransactionHistoryGamingXpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GamingXPTransactionHistoryResponse>>;

    /**
     * Get user\'s gaming XP transaction history with time filtering and pagination
     */
    getDevourplayTransactionHistoryGamingXp(requestParameters: GetDevourplayTransactionHistoryGamingXpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GamingXPTransactionHistoryResponse>;

    /**
     * Get user\'s LootBox redemption history (prizes received) with time filtering and pagination
     * @param {TimeFilter} [timeFilter] Time period for filtering transactions (defaults to \&#39;all\&#39;)
     * @param {number} [limit] Number of transactions to return
     * @param {number} [offset] Number of transactions to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevourPlayApiInterface
     */
    getDevourplayTransactionHistoryLootboxRedemptionRaw(requestParameters: GetDevourplayTransactionHistoryLootboxRedemptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LootboxRedemptionTransactionHistoryResponse>>;

    /**
     * Get user\'s LootBox redemption history (prizes received) with time filtering and pagination
     */
    getDevourplayTransactionHistoryLootboxRedemption(requestParameters: GetDevourplayTransactionHistoryLootboxRedemptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LootboxRedemptionTransactionHistoryResponse>;

    /**
     * Get user\'s LootBox purchase history with time filtering and pagination
     * @param {TimeFilter} [timeFilter] Time period for filtering transactions (defaults to \&#39;all\&#39;)
     * @param {number} [limit] Number of transactions to return
     * @param {number} [offset] Number of transactions to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevourPlayApiInterface
     */
    getDevourplayTransactionHistoryLootboxesRaw(requestParameters: GetDevourplayTransactionHistoryLootboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LootboxTransactionHistoryResponse>>;

    /**
     * Get user\'s LootBox purchase history with time filtering and pagination
     */
    getDevourplayTransactionHistoryLootboxes(requestParameters: GetDevourplayTransactionHistoryLootboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LootboxTransactionHistoryResponse>;

    /**
     * Get user\'s LootShop order history with time filtering and pagination
     * @param {TimeFilter} [timeFilter] Time period for filtering transactions (defaults to \&#39;all\&#39;)
     * @param {number} [limit] Number of transactions to return
     * @param {number} [offset] Number of transactions to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevourPlayApiInterface
     */
    getDevourplayTransactionHistoryLootshopRaw(requestParameters: GetDevourplayTransactionHistoryLootshopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LootshopTransactionHistoryResponse>>;

    /**
     * Get user\'s LootShop order history with time filtering and pagination
     */
    getDevourplayTransactionHistoryLootshop(requestParameters: GetDevourplayTransactionHistoryLootshopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LootshopTransactionHistoryResponse>;

    /**
     * Get the user\'s LootShop Credit ledger with time filtering and pagination. This is store credit (won or granted), distinct from transaction-history-lootshop which returns LootShop orders.
     * @param {TimeFilter} [timeFilter] Time period for filtering transactions (defaults to \&#39;all\&#39;)
     * @param {string} [startDate] ISO date string, required when timeFilter is \&#39;custom\&#39;
     * @param {string} [endDate] ISO date string, required when timeFilter is \&#39;custom\&#39;
     * @param {number} [limit] Number of transactions to return
     * @param {number} [offset] Number of transactions to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevourPlayApiInterface
     */
    getDevourplayTransactionHistoryLootshopCreditRaw(requestParameters: GetDevourplayTransactionHistoryLootshopCreditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LootshopCreditTransactionHistoryResponse>>;

    /**
     * Get the user\'s LootShop Credit ledger with time filtering and pagination. This is store credit (won or granted), distinct from transaction-history-lootshop which returns LootShop orders.
     */
    getDevourplayTransactionHistoryLootshopCredit(requestParameters: GetDevourplayTransactionHistoryLootshopCreditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LootshopCreditTransactionHistoryResponse>;

    /**
     * Get user\'s XP transaction history with time filtering and pagination
     * @param {TimeFilter} [timeFilter] Time period for filtering transactions (defaults to \&#39;all\&#39;). Use \&#39;custom\&#39; with startDate and endDate for custom ranges.
     * @param {Date} [startDate] Start date for custom range (ISO string). Required when timeFilter is \&#39;custom\&#39;.
     * @param {Date} [endDate] End date for custom range (ISO string). Required when timeFilter is \&#39;custom\&#39;.
     * @param {number} [limit] Number of transactions to return
     * @param {number} [offset] Number of transactions to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevourPlayApiInterface
     */
    getDevourplayTransactionHistoryXpRaw(requestParameters: GetDevourplayTransactionHistoryXpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<XPTransactionHistoryResponse>>;

    /**
     * Get user\'s XP transaction history with time filtering and pagination
     */
    getDevourplayTransactionHistoryXp(requestParameters: GetDevourplayTransactionHistoryXpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<XPTransactionHistoryResponse>;

    /**
     * Retrieves Overwolf user stats with fully populated reward data.  **API Change (v2.1.0):** Milestone rewards now include populated `rewardConfig` objects with complete reward information (type, amount, name) instead of just `rewardConfigId` references. This allows frontends to display accurate reward amounts for milestone-based quests. 
     * @param {string} [gameId] Optional Overwolf game ID to filter user stats.
     * @param {string} [rewardId] Optional reward ID to filter user stats.
     * @param {'EVENT' | 'TIME'} [rewardCategory] Optional reward category (\&quot;EVENT\&quot; or \&quot;TIME\&quot;) to filter user stats.
     * @param {number} [page] Page number for pagination (1-indexed).
     * @param {number} [pageSize] Number of items per page (max 100).
     * @param {number} [daysBack] Filter to quests with activity in the last N days.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevourPlayApiInterface
     */
    getDevourplayUserQuestStatsRaw(requestParameters: GetDevourplayUserQuestStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserQuestStatsResponse>>;

    /**
     * Retrieves Overwolf user stats with fully populated reward data.  **API Change (v2.1.0):** Milestone rewards now include populated `rewardConfig` objects with complete reward information (type, amount, name) instead of just `rewardConfigId` references. This allows frontends to display accurate reward amounts for milestone-based quests. 
     */
    getDevourplayUserQuestStats(requestParameters: GetDevourplayUserQuestStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserQuestStatsResponse>;

    /**
     * Returns the status of the latest GameTrackingHealthSnapshot for a gameId. Status only — `statusReason` and the feature breakdown are operator data and are never returned here. Consumed by the in-app status chip and the at-risk competition banner. Public — no authentication required. Cached 60s in Redis to absorb chip-poll bursts. 
     * @summary Get public game tracking health
     * @param {string} gameId MongoDB ObjectId of the OWGame
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevourPlayApiInterface
     */
    getGameHealthGameIdRaw(requestParameters: GetGameHealthGameIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GameHealthResponse>>;

    /**
     * Returns the status of the latest GameTrackingHealthSnapshot for a gameId. Status only — `statusReason` and the feature breakdown are operator data and are never returned here. Consumed by the in-app status chip and the at-risk competition banner. Public — no authentication required. Cached 60s in Redis to absorb chip-poll bursts. 
     * Get public game tracking health
     */
    getGameHealthGameId(requestParameters: GetGameHealthGameIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GameHealthResponse>;

}

/**
 * 
 */
export class DevourPlayApi extends runtime.BaseAPI implements DevourPlayApiInterface {

    /**
     * Stores a zipped log bundle from the DevourPlay Electron client. Anonymous uploads are accepted under `anonymous/`. Max 10MB.
     */
    async createDevourplayHelpTicketRaw(requestParameters: CreateDevourplayHelpTicketRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateHelpTicketResponse>> {
        if (requestParameters['logFile'] == null) {
            throw new runtime.RequiredError(
                'logFile',
                'Required parameter "logFile" was null or undefined when calling createDevourplayHelpTicket().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['logFile'] != null) {
            formParams.append('logFile', requestParameters['logFile'] as any);
        }

        if (requestParameters['name'] != null) {
            formParams.append('name', requestParameters['name'] as any);
        }

        if (requestParameters['description'] != null) {
            formParams.append('description', requestParameters['description'] as any);
        }


        let urlPath = `/devourplay/help-ticket`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateHelpTicketResponseFromJSON(jsonValue));
    }

    /**
     * Stores a zipped log bundle from the DevourPlay Electron client. Anonymous uploads are accepted under `anonymous/`. Max 10MB.
     */
    async createDevourplayHelpTicket(requestParameters: CreateDevourplayHelpTicketRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateHelpTicketResponse> {
        const response = await this.createDevourplayHelpTicketRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all games with their quests and user progress in a single optimized call.
     */
    async getDevourplayAllGamesQuestsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllGamesQuestsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/devourplay/all-games-quests`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAllGamesQuestsResponseFromJSON(jsonValue));
    }

    /**
     * Get all games with their quests and user progress in a single optimized call.
     */
    async getDevourplayAllGamesQuests(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllGamesQuestsResponse> {
        const response = await this.getDevourplayAllGamesQuestsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get the authenticated user\'s DevourPlay Competitive Tier
     */
    async getDevourplayCompetitiveTierRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCompetitiveTierResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/devourplay/competitive-tier`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCompetitiveTierResponseFromJSON(jsonValue));
    }

    /**
     * Get the authenticated user\'s DevourPlay Competitive Tier
     */
    async getDevourplayCompetitiveTier(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCompetitiveTierResponse> {
        const response = await this.getDevourplayCompetitiveTierRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get user\'s favorite games ranked by total play time
     */
    async getDevourplayFavoriteGamesRaw(requestParameters: GetDevourplayFavoriteGamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFavoriteGamesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/devourplay/favorite-games`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFavoriteGamesResponseFromJSON(jsonValue));
    }

    /**
     * Get user\'s favorite games ranked by total play time
     */
    async getDevourplayFavoriteGames(requestParameters: GetDevourplayFavoriteGamesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFavoriteGamesResponse> {
        const response = await this.getDevourplayFavoriteGamesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get user\'s stats for a specific game with time filtering. Aggregates XP from time-played rewards (via OWReward) and quest rewards (via QuestConfig).
     */
    async getDevourplayGameStatsGameIdRaw(requestParameters: GetDevourplayGameStatsGameIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GameStatsResponse>> {
        if (requestParameters['gameId'] == null) {
            throw new runtime.RequiredError(
                'gameId',
                'Required parameter "gameId" was null or undefined when calling getDevourplayGameStatsGameId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['timeFilter'] != null) {
            queryParameters['timeFilter'] = requestParameters['timeFilter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/devourplay/game-stats/{gameId}`;
        urlPath = urlPath.replace(`{${"gameId"}}`, encodeURIComponent(String(requestParameters['gameId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GameStatsResponseFromJSON(jsonValue));
    }

    /**
     * Get user\'s stats for a specific game with time filtering. Aggregates XP from time-played rewards (via OWReward) and quest rewards (via QuestConfig).
     */
    async getDevourplayGameStatsGameId(requestParameters: GetDevourplayGameStatsGameIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GameStatsResponse> {
        const response = await this.getDevourplayGameStatsGameIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The five games the Play hero rotates through, most recently played first. Distinct from /devourplay/favorite-games, which returns the user\'s FULL roster ranked by total playtime for the roster grid — this returns a fixed five-slot rotation, seeded from the weekly platform top five for a user with no play history so the hero is never empty. 
     */
    async getDevourplayHeroGamesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetHeroGamesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/devourplay/hero-games`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetHeroGamesResponseFromJSON(jsonValue));
    }

    /**
     * The five games the Play hero rotates through, most recently played first. Distinct from /devourplay/favorite-games, which returns the user\'s FULL roster ranked by total playtime for the roster grid — this returns a fixed five-slot rotation, seeded from the weekly platform top five for a user with no play history so the hero is never empty. 
     */
    async getDevourplayHeroGames(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetHeroGamesResponse> {
        const response = await this.getDevourplayHeroGamesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets the user\'s last gaming session and recent activity
     */
    async getDevourplayLastSessionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LastSessionResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/devourplay/last-session`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LastSessionResponseFromJSON(jsonValue));
    }

    /**
     * Gets the user\'s last gaming session and recent activity
     */
    async getDevourplayLastSession(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LastSessionResponse> {
        const response = await this.getDevourplayLastSessionRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getDevourplayMyNetworkStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MyNetworkStatusResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/devourplay/my-network-status`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MyNetworkStatusResponseFromJSON(jsonValue));
    }

    /**
     */
    async getDevourplayMyNetworkStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MyNetworkStatusResponse> {
        const response = await this.getDevourplayMyNetworkStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get user\'s play statistics with time filtering
     */
    async getDevourplayPlayStatsRaw(requestParameters: GetDevourplayPlayStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlayStatsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['timeFilter'] != null) {
            queryParameters['timeFilter'] = requestParameters['timeFilter'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/devourplay/play-stats`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlayStatsResponseFromJSON(jsonValue));
    }

    /**
     * Get user\'s play statistics with time filtering
     */
    async getDevourplayPlayStats(requestParameters: GetDevourplayPlayStatsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlayStatsResponse> {
        const response = await this.getDevourplayPlayStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the most popular quest-enabled games ranked by total play time across all users
     */
    async getDevourplayPopularQuestGamesRaw(requestParameters: GetDevourplayPopularQuestGamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPopularQuestGamesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/devourplay/popular-quest-games`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPopularQuestGamesResponseFromJSON(jsonValue));
    }

    /**
     * Get the most popular quest-enabled games ranked by total play time across all users
     */
    async getDevourplayPopularQuestGames(requestParameters: GetDevourplayPopularQuestGamesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPopularQuestGamesResponse> {
        const response = await this.getDevourplayPopularQuestGamesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get user\'s food order history with time filtering and pagination
     */
    async getDevourplayTransactionHistoryFoodRaw(requestParameters: GetDevourplayTransactionHistoryFoodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FoodTransactionHistoryResponse>> {
        const queryParameters: any = {};

        if (requestParameters['timeFilter'] != null) {
            queryParameters['timeFilter'] = requestParameters['timeFilter'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/devourplay/transaction-history-food`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FoodTransactionHistoryResponseFromJSON(jsonValue));
    }

    /**
     * Get user\'s food order history with time filtering and pagination
     */
    async getDevourplayTransactionHistoryFood(requestParameters: GetDevourplayTransactionHistoryFoodRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FoodTransactionHistoryResponse> {
        const response = await this.getDevourplayTransactionHistoryFoodRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get user\'s Fuel transaction history with time filtering and pagination
     */
    async getDevourplayTransactionHistoryFuelRaw(requestParameters: GetDevourplayTransactionHistoryFuelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FuelTransactionHistoryResponse>> {
        const queryParameters: any = {};

        if (requestParameters['timeFilter'] != null) {
            queryParameters['timeFilter'] = requestParameters['timeFilter'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/devourplay/transaction-history-fuel`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FuelTransactionHistoryResponseFromJSON(jsonValue));
    }

    /**
     * Get user\'s Fuel transaction history with time filtering and pagination
     */
    async getDevourplayTransactionHistoryFuel(requestParameters: GetDevourplayTransactionHistoryFuelRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FuelTransactionHistoryResponse> {
        const response = await this.getDevourplayTransactionHistoryFuelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get user\'s gaming XP transaction history with time filtering and pagination
     */
    async getDevourplayTransactionHistoryGamingXpRaw(requestParameters: GetDevourplayTransactionHistoryGamingXpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GamingXPTransactionHistoryResponse>> {
        const queryParameters: any = {};

        if (requestParameters['timeFilter'] != null) {
            queryParameters['timeFilter'] = requestParameters['timeFilter'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/devourplay/transaction-history-gaming-xp`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GamingXPTransactionHistoryResponseFromJSON(jsonValue));
    }

    /**
     * Get user\'s gaming XP transaction history with time filtering and pagination
     */
    async getDevourplayTransactionHistoryGamingXp(requestParameters: GetDevourplayTransactionHistoryGamingXpRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GamingXPTransactionHistoryResponse> {
        const response = await this.getDevourplayTransactionHistoryGamingXpRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get user\'s LootBox redemption history (prizes received) with time filtering and pagination
     */
    async getDevourplayTransactionHistoryLootboxRedemptionRaw(requestParameters: GetDevourplayTransactionHistoryLootboxRedemptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LootboxRedemptionTransactionHistoryResponse>> {
        const queryParameters: any = {};

        if (requestParameters['timeFilter'] != null) {
            queryParameters['timeFilter'] = requestParameters['timeFilter'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/devourplay/transaction-history-lootbox-redemption`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LootboxRedemptionTransactionHistoryResponseFromJSON(jsonValue));
    }

    /**
     * Get user\'s LootBox redemption history (prizes received) with time filtering and pagination
     */
    async getDevourplayTransactionHistoryLootboxRedemption(requestParameters: GetDevourplayTransactionHistoryLootboxRedemptionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LootboxRedemptionTransactionHistoryResponse> {
        const response = await this.getDevourplayTransactionHistoryLootboxRedemptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get user\'s LootBox purchase history with time filtering and pagination
     */
    async getDevourplayTransactionHistoryLootboxesRaw(requestParameters: GetDevourplayTransactionHistoryLootboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LootboxTransactionHistoryResponse>> {
        const queryParameters: any = {};

        if (requestParameters['timeFilter'] != null) {
            queryParameters['timeFilter'] = requestParameters['timeFilter'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/devourplay/transaction-history-lootboxes`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LootboxTransactionHistoryResponseFromJSON(jsonValue));
    }

    /**
     * Get user\'s LootBox purchase history with time filtering and pagination
     */
    async getDevourplayTransactionHistoryLootboxes(requestParameters: GetDevourplayTransactionHistoryLootboxesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LootboxTransactionHistoryResponse> {
        const response = await this.getDevourplayTransactionHistoryLootboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get user\'s LootShop order history with time filtering and pagination
     */
    async getDevourplayTransactionHistoryLootshopRaw(requestParameters: GetDevourplayTransactionHistoryLootshopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LootshopTransactionHistoryResponse>> {
        const queryParameters: any = {};

        if (requestParameters['timeFilter'] != null) {
            queryParameters['timeFilter'] = requestParameters['timeFilter'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/devourplay/transaction-history-lootshop`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LootshopTransactionHistoryResponseFromJSON(jsonValue));
    }

    /**
     * Get user\'s LootShop order history with time filtering and pagination
     */
    async getDevourplayTransactionHistoryLootshop(requestParameters: GetDevourplayTransactionHistoryLootshopRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LootshopTransactionHistoryResponse> {
        const response = await this.getDevourplayTransactionHistoryLootshopRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the user\'s LootShop Credit ledger with time filtering and pagination. This is store credit (won or granted), distinct from transaction-history-lootshop which returns LootShop orders.
     */
    async getDevourplayTransactionHistoryLootshopCreditRaw(requestParameters: GetDevourplayTransactionHistoryLootshopCreditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LootshopCreditTransactionHistoryResponse>> {
        const queryParameters: any = {};

        if (requestParameters['timeFilter'] != null) {
            queryParameters['timeFilter'] = requestParameters['timeFilter'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/devourplay/transaction-history-lootshop-credit`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LootshopCreditTransactionHistoryResponseFromJSON(jsonValue));
    }

    /**
     * Get the user\'s LootShop Credit ledger with time filtering and pagination. This is store credit (won or granted), distinct from transaction-history-lootshop which returns LootShop orders.
     */
    async getDevourplayTransactionHistoryLootshopCredit(requestParameters: GetDevourplayTransactionHistoryLootshopCreditRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LootshopCreditTransactionHistoryResponse> {
        const response = await this.getDevourplayTransactionHistoryLootshopCreditRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get user\'s XP transaction history with time filtering and pagination
     */
    async getDevourplayTransactionHistoryXpRaw(requestParameters: GetDevourplayTransactionHistoryXpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<XPTransactionHistoryResponse>> {
        const queryParameters: any = {};

        if (requestParameters['timeFilter'] != null) {
            queryParameters['timeFilter'] = requestParameters['timeFilter'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/devourplay/transaction-history-xp`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => XPTransactionHistoryResponseFromJSON(jsonValue));
    }

    /**
     * Get user\'s XP transaction history with time filtering and pagination
     */
    async getDevourplayTransactionHistoryXp(requestParameters: GetDevourplayTransactionHistoryXpRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<XPTransactionHistoryResponse> {
        const response = await this.getDevourplayTransactionHistoryXpRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves Overwolf user stats with fully populated reward data.  **API Change (v2.1.0):** Milestone rewards now include populated `rewardConfig` objects with complete reward information (type, amount, name) instead of just `rewardConfigId` references. This allows frontends to display accurate reward amounts for milestone-based quests. 
     */
    async getDevourplayUserQuestStatsRaw(requestParameters: GetDevourplayUserQuestStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserQuestStatsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['gameId'] != null) {
            queryParameters['gameId'] = requestParameters['gameId'];
        }

        if (requestParameters['rewardId'] != null) {
            queryParameters['rewardId'] = requestParameters['rewardId'];
        }

        if (requestParameters['rewardCategory'] != null) {
            queryParameters['rewardCategory'] = requestParameters['rewardCategory'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['daysBack'] != null) {
            queryParameters['daysBack'] = requestParameters['daysBack'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/devourplay/user-quest-stats`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserQuestStatsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves Overwolf user stats with fully populated reward data.  **API Change (v2.1.0):** Milestone rewards now include populated `rewardConfig` objects with complete reward information (type, amount, name) instead of just `rewardConfigId` references. This allows frontends to display accurate reward amounts for milestone-based quests. 
     */
    async getDevourplayUserQuestStats(requestParameters: GetDevourplayUserQuestStatsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserQuestStatsResponse> {
        const response = await this.getDevourplayUserQuestStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the status of the latest GameTrackingHealthSnapshot for a gameId. Status only — `statusReason` and the feature breakdown are operator data and are never returned here. Consumed by the in-app status chip and the at-risk competition banner. Public — no authentication required. Cached 60s in Redis to absorb chip-poll bursts. 
     * Get public game tracking health
     */
    async getGameHealthGameIdRaw(requestParameters: GetGameHealthGameIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GameHealthResponse>> {
        if (requestParameters['gameId'] == null) {
            throw new runtime.RequiredError(
                'gameId',
                'Required parameter "gameId" was null or undefined when calling getGameHealthGameId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/game-health/{gameId}`;
        urlPath = urlPath.replace(`{${"gameId"}}`, encodeURIComponent(String(requestParameters['gameId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GameHealthResponseFromJSON(jsonValue));
    }

    /**
     * Returns the status of the latest GameTrackingHealthSnapshot for a gameId. Status only — `statusReason` and the feature breakdown are operator data and are never returned here. Consumed by the in-app status chip and the at-risk competition banner. Public — no authentication required. Cached 60s in Redis to absorb chip-poll bursts. 
     * Get public game tracking health
     */
    async getGameHealthGameId(requestParameters: GetGameHealthGameIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GameHealthResponse> {
        const response = await this.getGameHealthGameIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetDevourplayUserQuestStatsRewardCategoryEnum = {
    Event: 'EVENT',
    Time: 'TIME'
} as const;
export type GetDevourplayUserQuestStatsRewardCategoryEnum = typeof GetDevourplayUserQuestStatsRewardCategoryEnum[keyof typeof GetDevourplayUserQuestStatsRewardCategoryEnum];
